import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const DEFAULT_WORDS = [
  "PRESS BUTTONS",
  "TOUCH GRASS",
  "ANALOG IS BACK",
  "NO SUBSCRIPTION",
  "PHYSICAL MEDIA FOREVER",
  "BUILT DIFFERENT",
];

export default function MarqueeBand({ bg = "bg-yellow", text = "text-charcoal", words = DEFAULT_WORDS, speed = 30 }) {
  return (
    <div data-testid="marquee-band" className={`overflow-hidden border-y-2 border-charcoal ${bg} ${text} py-3`}>
      <Marquee speed={speed} gradient={false}>
        {words.map((w, i) => (
          <span key={i} className="flex items-center gap-6 pr-6 font-display text-lg font-bold uppercase tracking-tight md:text-2xl">
            {w}
            <Asterisk className="h-6 w-6" strokeWidth={3} />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
